import gql from 'graphql-tag';

export const AdminRebuildPolicyMutation = gql`
  mutation AdminRebuildPolicy($paymentId: String!, $force: Boolean) {
    rebuildInsurancePolicy(paymentId: $paymentId, force: $force) {
      triggered
    }
  }
`;

export const AdminResendPolicyEmailMutation = gql`
  mutation AdminResendPolicyEmail($paymentId: String!) {
    resendInsurancePolicyEmail(paymentId: $paymentId) {
      triggered
    }
  }
`;

export const AdminResendTransactionInvoiceMutation = gql`
  mutation AdminResendTransactionInvoice($paymentId: String!) {
    resendInsurancePolicyInvoice(paymentId: $paymentId) {
      triggered
    }
  }
`;

export const AdminReprintPolicyMutation = gql`
  mutation AdminReprintPolicy($paymentId: String!) {
    reprintInsurancePolicy(paymentId: $paymentId) {
      base64
    }
  }
`;

export const AdminReprintInvoiceMutation = gql`
  mutation AdminReprintInvoice($paymentId: String!) {
    reprintInvoice(paymentId: $paymentId) {
      base64
    }
  }
`;
